import { defineModel, serializable, castings as castTo } from '../model'

class ReasonOfCancellation {
    /**
     * ...
     */

    @serializable()
    value1: string

    @serializable()
    value2: string

}

export default defineModel(ReasonOfCancellation)
